'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = null;

var Country = function Country() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes2.default.COUNTRY_RECEIVED:
      return payload.country;
    default:
      return state;
  }
};

exports.default = Country;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/Country.js
// module id = 384
// module chunks = 3 4 5